import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

export const SET_DATE = "./riskMembers/SET_DATE";
export const SET_LOADING = "./riskMembers/SET_LOADING";
export const FETCH_CURRENT_USER = "./riskMembers/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "./riskMembers/FETCH_CURRENT_USER_SUCCESS";
export const SET_UPDATES_LOADING = "./riskMembers/SET_UPDATES_LOADING";
export const FETCH_TABLE_SUCCESS = "./riskMembers/FETCH_TABLE_SUCCESS";
export const SET_TOGGLE = "./riskMembers/HANDLE_TOGGLE";
export const SET_VIEW = "./riskMembers/SET_VIEW";
export const SET_RISK_LEVELS = "./riskMembers/SET_RISK_LEVELS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  handleToggle: createAction(SET_TOGGLE),
  setView: createAction(SET_VIEW),
  setRiskLevels: createAction(SET_RISK_LEVELS)
};
export default function* watchActiveMembers() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(SET_TOGGLE, fetchData);
  yield takeLatest(SET_VIEW, fetchData);
  yield takeLatest(SET_RISK_LEVELS, fetchData);
}
export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });

  yield put({ type: SET_LOADING, payload: true });
  yield setDates();

  // Default non-ChaseIQ users to Zero Visits — they can't toggle to Prediction.
  const { chaseIqEnabled, permissions, isAdmin } = yield select(
    (state) => state.commonReducer.commonProps
  );
  const hasChaseIqAccess =
    chaseIqEnabled && (isAdmin || permissions?.includes("dashboard_chase_iq"));
  yield put({ type: SET_VIEW, payload: hasChaseIqAccess ? "by_prediction" : "by_visits" });
  yield put({ type: SET_LOADING, payload: false });
}

function* setDates() {
  const endDate = yield select((state) => state.riskMembers.currentUser.calendarEndDate);

  yield put({
    type: SET_DATE,
    payload: endDate
  });
}

function* fetchData() {
  const { date, includeFutureVisits, view, riskLevels } = yield select(
    (state) => state.riskMembers
  );
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  const chartParams = {
    organization_id,
    short_url,
    date,
    include_future_visits: includeFutureVisits,
    view
  };

  if (view === "by_prediction") {
    chartParams.risk_levels = riskLevels;
  }

  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    let { data: tableData } = yield call(
      axios.get,
      queryParams.apiVersion + "pages/memberships/members_at_risk_chart",
      { params: chartParams }
    );
    yield put({
      type: FETCH_TABLE_SUCCESS,
      payload: tableData
    });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}
